/* istanbul ignore file: please test in WEBSITE-7219 */
import { CompactUser } from 'src/context/user';
import {
  addToLocalStorageArrayEntry,
  hasInLocalStorageArrayEntry,
} from 'src/utils/webStorageArrayUtils';
import { HAS_SEEN_SOFT_SELL_STORAGE_KEY } from 'src/constants/storageKeys.const';
import { SoftSellScreenType } from 'src/apps/Monetisation/SoftSellScreen/index';

const getSoftSellStorageKey = (user: CompactUser, screenType: SoftSellScreenType) =>
  `${user.id}-${screenType}`;

export const doesNotHaveInSoftSellStorageEntry = (
  user: CompactUser | null,
  screenType: SoftSellScreenType,
) => {
  if (!user || user.isPro) return false;

  return !hasInLocalStorageArrayEntry(
    HAS_SEEN_SOFT_SELL_STORAGE_KEY,
    getSoftSellStorageKey(user, screenType),
  );
};

export const addToSoftSellStorageEntry = (
  user: CompactUser | null,
  screenType: SoftSellScreenType,
) => {
  if (!user) return;

  return addToLocalStorageArrayEntry(
    HAS_SEEN_SOFT_SELL_STORAGE_KEY,
    getSoftSellStorageKey(user, screenType),
  );
};
